import 'angular-gridster'

import { default as commonModule, LoggerService } from './../common/common.module'
import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { SERVICES_MODULE_NAME } from './../../services'
import { GridContextMenuService, GRID_CONTEXT_MENU_SERVICE_NAME } from '../../services/grid'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $STATE_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_NAME, SystemService, SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from '../../services/system'
import { MeterService, METER_SERVICE_NAME } from '../../services/meter'
import { USER_SESSION_SERVICE_NAME, UserSessionService, USER_SESSION_SERVICE_PROVIDER_NAME } from '../../services/user-session'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'
import { MetersController, MetersScope } from './meters.controller'
import { MeterCreateEditDirective } from './create-edit/meters-create-edit.directive'
import { MeterDetailsDirective } from './details/meters-details.directive'
import { MeterDefinitionsEditDirective } from './meter-definitions-edit/meter-definitions-edit.directive'
import { DefinitionEditDirective } from './definition-edit/definition-edit.directive'
import { StateProvider, StateService } from '@uirouter/angularjs'

//#region Asset Imports

import * as TEMPLATE from './meters.tpl.html'

//#endregion

// Consts

const CONTROLER_NAME: string = 'MetersController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'meterCreateEdit'
const DEFINITION_EDIT: string = 'definitionEdit'
const DETAILS_DIRECTIVE_NAME: string = 'meterDetails'
const METER_DEFINITIONS_EDIT: string = 'meterDefinitionsEdit'
const MODULE_NAME: string = 'simax.meters'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'Meters'
const MENU_INDEX: number = 4
const STATE_NAME: string = 'meters'
const STATE_URL: string = '/meters'

// Consts End

const module = angular.module(MODULE_NAME, [commonModule, apiModule, 'gridster', SERVICES_MODULE_NAME])

// Setup

module.controller(
    CONTROLER_NAME,
    [
        $SCOPE_SERVICE_NAME,
        $STATE_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'api',
        'logger',
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        METER_SERVICE_NAME,
        GRID_CONTEXT_MENU_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        SYSTEM_CONTEXT_LIST_SERVICE_NAME,
        (
            $scope: MetersScope,
            $state: StateService,
            $timeout: ng.ITimeoutService,
            api: Api,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            userSession: UserSessionService,
            meterService: MeterService,
            gridContextMenuService: GridContextMenuService,
            systemService: SystemService,
            systemContextListService: SystemContextListService
        ) => new MetersController(
            $scope,
            $state,
            $timeout,
            api,
            logger,
            localDictionary,
            userSession,
            meterService,
            gridContextMenuService,
            systemService,
            MeterService.REFERENCE_TYPE,
            MeterService.SIMAX_MODULE_NAME
        )
    ]
)

module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new MeterCreateEditDirective()])
module.directive(DETAILS_DIRECTIVE_NAME, [() => new MeterDetailsDirective()])
module.directive(METER_DEFINITIONS_EDIT, [() => new MeterDefinitionsEditDirective()])
module.directive(DEFINITION_EDIT, [() => new DefinitionEditDirective()])

module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Meter_IdMeter',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider.getLoggedOperatorAsync().then((loggedOperator: OpOperator) => {
        if (loggedOperator.hasPermission(Activity.METER_LIST)
            && !loggedOperator.hasPermission(Activity.METER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterModule)) {
            MenuItem.addMenuItem(
                ConfigHelper.getIconName(ConfigHelper.Icon.METERS),
                'meters',
                MODULE_NAME_LOCALIZATION_TEXT,
                STATE_NAME,
                MENU_INDEX
            )

            $stateProvider.state(STATE_NAME, {
                url: STATE_URL,
                controller: CONTROLER_NAME,
                template: TEMPLATE,
                params: { ids: null }
            })
        }
    })
}])

// Setup End

export default MODULE_NAME